var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.33325C1 4.22868 1.89543 3.33325 3 3.33325H19C20.1046 3.33325 21 4.22868 21 5.33325V15.4999C21 16.6045 20.1046 17.4999 19 17.4999H3C1.89543 17.4999 1 16.6045 1 15.4999V5.33325Z",
    stroke: "#A6A6A6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42131 4.63612C1.91709 4.17392 2.24409 3.33325 2.9281 3.33325H19.0719C19.7559 3.33325 20.0829 4.17392 19.5787 4.63612L13.0272 10.6417C11.8802 11.6931 10.1198 11.6931 8.97283 10.6417L2.42131 4.63612Z",
    stroke: "#A6A6A6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c246eaf6f5b0b8c5fb5eebef8d615b1f.svg";
export { ForwardRef as ReactComponent };